export default "__VITE_ASSET__CPneOlZn__"